import React, { useEffect, useState } from "react";
import { Phone } from "lucide-react";
import { businessInfo } from "../mock";

const CallStickyButton = () => {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <a
      href={`tel:${businessInfo.phoneRaw}`}
      className={`lg:hidden fixed bottom-5 right-5 z-50 bg-brand-red text-white rounded-full shadow-2xl pulse-ring transition-opacity duration-300 ${
        show ? "opacity-100" : "opacity-0 pointer-events-none"
      }`}
      aria-label="Call now"
    >
      <div className="flex items-center gap-2 px-5 py-3.5 font-semibold">
        <Phone className="w-5 h-5" />
        Call Now
      </div>
    </a>
  );
};

export default CallStickyButton;
